class InventoryCountController extends AbstractEntityEditController
	@register()
	@inject '$stateParams',
		'inventoryCount'
		'currencies'
		'shops'
		'stockLocations'
		'parseBool'
		'InventoryCountRepository'
		'InventoryCountLineItemRepository'
		'UserInformation'
		'entityTypeEnum': 'BACKEND_INVENTORY_COUNT_ENTITY_TYPE'
		'statusEnum': 'BACKEND_INVENTORY_COUNT_STATUS'

	initialize: ->
		@mainCrud.entityType = 'inventory.count'
		@mainCrud.entityTitle = 'inventory.count.open.new'
		@mainCrud.isNewEntity = true

		@notCountedProducts = []
		@undoState = null
		@productsFilterDTO = new FilterDTO({
			searchConfiguration:
				product:
					property: 'product_id'
					label: 'general.product'
					type: 'select'
					options:
						repository: 'ProductRepository'
			sortProperty: 'product_id'
			sortDirection: 'ASC'
			itemsCount: 0
		})
		@lineItemsFilterDTO = new FilterDTO({
			searchConfiguration:
				product:
					property: 'product_id'
					label: 'general.product'
					type: 'select'
					options:
						repository: 'ProductRepository'
				user:
					property: 'user_id'
					label: 'general.user'
					type: 'select'
					options:
						repository: 'UserRepository'
						text_property: 'full_name'
			sortProperty: 'product_id'
			sortDirection: 'ASC'
			itemsCount: 0
		})

		if @inventoryCount.id?
			@mainCrud.isNewEntity = false
			@mainCrud.entityTitle = 'inventory.count'
			@mainCrud.showSave = @inventoryCount.status == @statusEnum.OPEN
			@inventoryCount.count_all_products = @parseBool(@inventoryCount.count_all_products)

			@loadStats()
			if @inventoryCount.status == @statusEnum.CLOSED
				@loadUndoState()
		else
			@inventoryCount.is_blind_count = '0'
			@inventoryCount.status = @statusEnum.OPEN
			@inventoryCount.entity_type = @entityTypeEnum.MULTI_PART
			@inventoryCount.count_all_products = false

			if !_.isEmpty @$stateParams.stock_location_id
				@inventoryCount.stock_location_id = @$stateParams.stock_location_id
			else if @stockLocations.length == 1
				@inventoryCount.stock_location_id = @stockLocations[0].id

		@mainCrud.tabs = [
			{
				active: true
				title: 'wbo.tab.details'
				selector: '#tab-details'
			}
			{
				title: 'general.products'
				selector: '#tab-products'
				disabled: @mainCrud.isNewEntity
			}
		]
		@productTabs = [
			{
				active: true
				title: 'inventory.count.products.counted'
				selector: '#tab-counted-products'
			}
			{
				title: 'inventory.count.products.not_counted'
				selector: '#tab-not-counted-products'
				disabled: @inventoryCount.status != @statusEnum.OPEN
			}
		]

		@inventoryCount.line_items = []
		@hasStockLocationSet = @inventoryCount.stock_location_id?
		@userId = @UserInformation.getSubUser()?.id

		@setLockStatus()
		@setStockLocationShops()

	setStockLocationShops: ->
		if @inventoryCount.stock_location_id?
			@stockLocationShops = _.filter(@shops, {stock_location_id: @inventoryCount.stock_location_id})
		else
			@stockLocationShops = @shops

	setLockStatus: ->
		@isLocked = @inventoryCount.status != @statusEnum.OPEN
		@isMainDataLocked = @isLocked || !_.isEmpty @inventoryCount.line_items

	searchLineItems: ->
		if @mainCrud.isNewEntity
			@lineItems = []
			@lineItemsFilterDTO.itemsCount = 0
			@lineItemsFilterDTO.count = 0

			return

		query = @lineItemsFilterDTO.getQuery()
		query.with('user', 'product')

		shop = null

		if @inventoryCount.shop_id?
			shop = _.find(@stockLocationShops, {id: @inventoryCount.shop_id})

		if !shop?
			query.criteria('inventory_count_id', '=', @inventoryCount.id)
		else
			productCriteria = query.criteria('inventory_count_id', '=', @inventoryCount.id)
			productCriteria.and('product_variant_id', 'IS' , 'NULL')
			productCriteria.and('product_product_data.price_region_id', '=', shop.price_region_id)

			productVariantCriteria = query.criteria('inventory_count_id', '=', @inventoryCount.id, 'OR')
			productVariantCriteria.and('product_variant_id', 'IS NOT', 'NULL')
			productVariantCriteria.and('product_variant_product_data.price_region_id', '=', shop.price_region_id)

			query.with('user', 'product', 'product.product_data', 'product_variant', 'product_variant.product_data')

		@InventoryCountLineItemRepository
			.getEntitiesWithCount(query)
			.then (response) =>
				@lineItems = response.data

				@lineItemsFilterDTO.itemsCount = @lineItems.length
				@lineItemsFilterDTO.count = response.count

				for lineItem in @lineItems
					existingLineItem = @findLineItem(lineItem.id)

					if !existingLineItem?
						continue

					lineItem.counted = existingLineItem.counted ? lineItem.counted
					lineItem.deleted = existingLineItem.deleted ? false

	searchNotCountedProducts: ->
		if @inventoryCount.status == @statusEnum.CLOSED
			return

		productId = @productsFilterDTO.searchConfiguration.product.value
		query = @productsFilterDTO.getQuery()

		@InventoryCountRepository
			.getNotCountedProducts(@inventoryCount.id, productId, query.pagination.offset, query.pagination.limit)
			.then (response) =>
				@notCountedProducts = response

				@productsFilterDTO.itemsCount = @notCountedProducts.length

				for product in @notCountedProducts
					product.counted = @findLineItem(null, product.id, product.product_variant_id)?.counted

	loadStats: ->
		@InventoryCountRepository
			.getStats(@inventoryCount.id)
			.then (response) =>
				@stats = response

				@mainCrud.tabs[1].subtitle = "(#{@stats.total_items})"

	loadUndoState: ->
		@InventoryCountRepository
			.getUndoState(@inventoryCount.id)
			.then (response) =>
				@undoState = response

				if angular.isDefined(response.reversed_at)
					@inventoryCount.reversed_at = response.reversed_at

				return response
			.catch =>
				@undoState = null

	reloadInventoryCount: ->
		@inventoryCount.line_items = []

		@loadStats()
		@searchNotCountedProducts()
		@searchLineItems()

	save: (title = null) ->
		title ?= if @mainCrud.isNewEntity then 'alert.saved' else 'alert.updated'

		inventoryCountCopy = @beforeSave()

		@InventoryCountRepository
			.save(inventoryCountCopy, @mainCrud.isNewEntity, true)
			.then (response) =>
				@inventoryCount.status = response.data.status

				if angular.isDefined(response.data.count_all_products)
					@inventoryCount.count_all_products = @parseBool(response.data.count_all_products)

				if angular.isDefined(response.data.reversed_at)
					@inventoryCount.reversed_at = response.data.reversed_at

				@setLockStatus()

				@mainCrud.showSave = @inventoryCount.status == @statusEnum.OPEN
				@productTabs[1].disabled = @inventoryCount.status != @statusEnum.OPEN

				@reloadInventoryCount()

				if @inventoryCount.status == @statusEnum.CLOSED
					@loadUndoState()
				else
					@undoState = null

				@afterSave response
			.catch (response) =>
				@handleErrors response

	beforeSave: ->
		inventoryCount = angular.copy @inventoryCount
		inventoryCount.timestamp = moment().unix()

		return inventoryCount

	close: ->
		@mainCrud.saving = true
		@inventoryCount.status = @statusEnum.CLOSED
		@save('general.closed')

	undo: ->
		if !@inventoryCount.id?
			return

		@mainCrud.saving = true

		@InventoryCountRepository
			.undo(@inventoryCount.id)
			.then (response) =>
				@undoState = response

				if angular.isDefined(response.reversed_at)
					@inventoryCount.reversed_at = response.reversed_at

					@ToastService.add(
						@translate('inventory.count.undo.completed'),
						@translate('inventory.count'),
						@translate('general.success'),
						'success',
					)

				@mainCrud.saving = false
			.catch (response) =>
				@handleErrors response

	delete: ->
		@deleteEntity @InventoryCountRepository, @inventoryCount, undefined, 'id', 'id'

	onLineItemDelete: (lineItem) ->
		lineItem.deleted = true

		existingLineItem = @findLineItem(lineItem.id)

		if existingLineItem?
			existingLineItem.deleted = true
		else
			@inventoryCount.line_items.push {
				id: lineItem.id
				user_id: @userId
				deleted: true
			}

		@triggerFormChange()

	onLineItemUndelete: (lineItem) ->
		lineItem.deleted = false
		@inventoryCount.line_items = _.reject(@inventoryCount.line_items, {id: lineItem.id})

	onLineItemCount: (lineItem) ->
		existingLineItem = @findLineItem(lineItem.id)

		if existingLineItem?
			existingLineItem.counted = lineItem.counted
		else
			@inventoryCount.line_items.push {
				id: lineItem.id
				user_id: @userId
				counted: lineItem.counted
			}

	onProductCount: (product) ->
		existingLineItem = @findLineItem(null, product.id, product.product_variant_id)

		if existingLineItem?
			existingLineItem.counted = product.counted
		else
			@inventoryCount.line_items.push {
				product_id: product.id
				product_variant_id: product.product_variant_id
				user_id: @userId
				name: product.product_variant_name ? product.name
				counted: product.counted
			}

	findLineItem: (id = null, productId = null, productVariantId = null) ->
		if _.isEmpty @inventoryCount.line_items
			return null

		if id?
			return _.find(@inventoryCount.line_items, {id: id})

		return _.find(@inventoryCount.line_items, {product_id: productId, product_variant_id: productVariantId})
